import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router";
import { useLocation } from "react-router-dom";

import {
	CoAppDataGridMain,
	CoAppOrganizationSettingsMain,
	CoAppUserProfileMain,
} from "./components/global/styled/global.styled";
import ResponsiveAppBar from "./components/header";
import SidebarNavigation, {
	NAV_DRAWER_WIDTH_COLLAPSED,
	useNavDrawerExpandedWidth,
} from "./components/navigation/SidebarNavigation";
import { CollectionsProvider } from "./components/settings/collections/CollectionsContext";
import CoAppGradientDefs from "./components/rule-canvas-builder/nodes/CoAppGradientDefs";
import pages from "./constants/pages";
import { selectIsSidebarNavCollapsed, setIsSidebarNavCollapsed } from "./redux/navigationSlice";

const WithNavRoute = () => {
	const dispatch = useDispatch();
	const userIsNavCollapsed = useSelector(selectIsSidebarNavCollapsed);
	const expandedNavWidth = useNavDrawerExpandedWidth();
	const location = useLocation();
	const pathItems = location.pathname.split("/").slice(1);
	const isUserProfile = location.pathname.includes("users") && !isNaN(parseInt(pathItems[2]));
	const isOrganizationSettings = location.pathname === pages.organizationManagement;
	const isRuleEditOrCreate = location.pathname.includes("rules") && !location.pathname.includes("library") && !location.pathname.includes("trash");
	const isSettingsSubPage = pathItems.length === 4;

	// On the rule builder, force the sidebar collapsed regardless of user
	// preference — the canvas needs maximum horizontal real estate. Canvas
	// tools (Figma, n8n) all do this. Other pages respect user preference.
	const isNavCollapsed = isRuleEditOrCreate ? true : userIsNavCollapsed;
	const drawerWidth = isNavCollapsed ? NAV_DRAWER_WIDTH_COLLAPSED : expandedNavWidth;
	// Other pages keep an 18px gutter between the sidebar and the content card.
	// The rule builder sits flush against the sidebar (no gutter) so the toolbox
	// panel, its section dividers, and the footer's top border all run edge-to-
	// edge next to the menu — and the toolbox's own left/right padding reads as
	// symmetric instead of left = gutter + padding.
	const sidebarOffset = drawerWidth + (isRuleEditOrCreate ? 0 : 18);

	let ContentWrapper;

	if (isUserProfile && !isSettingsSubPage) {
		ContentWrapper = CoAppUserProfileMain;
	} else if (isOrganizationSettings) {
		ContentWrapper = CoAppOrganizationSettingsMain;
	} else {
		ContentWrapper = CoAppDataGridMain;
	}

	return (
		<CollectionsProvider>
			{/* Global SVG <defs> with the 6 brand gradients. Mounted at this
			    layout level so any descendant SVG icon (sidebar, toolbox,
			    canvas) can reference them via fill="url(#coapp-grad-…)". */}
			<CoAppGradientDefs />
			<ResponsiveAppBar leftOffset={drawerWidth} />
			<SidebarNavigation
				isCollapsed={isNavCollapsed}
				onToggle={() => dispatch(setIsSidebarNavCollapsed(!isNavCollapsed))}
			/>
			<ContentWrapper style={{ "--sidebar-offset": `${sidebarOffset}px` }}>
				<Outlet />
			</ContentWrapper>
		</CollectionsProvider>
	);
};

export default WithNavRoute;
